import { render, staticRenderFns } from "./ClinimetricsButton.vue?vue&type=template&id=6e5126b5&"
import script from "./ClinimetricsButton.vue?vue&type=script&lang=js&"
export * from "./ClinimetricsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports